import VideoOverview from "../components/overview/VideoOverview";
import { motion } from "framer-motion";

export default function Notebook() {
  return (
    <div className="w-full max-w-[1400px] px-4 md:px-8 flex flex-col h-full">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mb-8">
        <h2 className="text-4xl font-extrabold tracking-tighter flex items-center gap-4">
          <span className="text-electric">✦</span> Video Overview
        </h2>
        <p className="text-white/50 mt-2 text-lg font-light tracking-wide">
          Transform your knowledge into cinematic AI educational content.
        </p>
      </motion.div>
      
      <div className="flex-1 w-full relative z-10">
        <VideoOverview />
      </div>
    </div>
  );
}
